import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { Flex } from 'foundations-components/components/Flex';
import { getFullUrl } from 'hubspot-url-utils';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Header = () => {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    backgroundColor: "fill-accent-neutral-default",
    inlineSize: "100%",
    justifyContent: "center",
    minBlockSize: "56px",
    paddingBlock: "200",
    children: /*#__PURE__*/_jsx(Link, {
      href: `${getFullUrl('app')}/portal-recommend/l?slug=academy`,
      underline: false,
      use: "unstyled",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Logo, {
          inlineSize: "83px",
          marginInlineEnd: "200",
          name: "hubspot-wordmark--light"
        }), /*#__PURE__*/_jsx(Text, {
          as: "h4",
          color: "text-core-on-fill-default",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "profilePage.header.hubspotAcademyAltText"
          })
        })]
      })
    })
  });
};